import { type ConfirmationModalData, useConfirmationModal } from '@customerio/pluma-components/react';
import { useStore } from '@nanostores/react';
import { atom } from 'nanostores';
import { useCallback } from 'react';

import { OPTIMIZATION_THRESHOLD_SIZE_MB } from '../utils';

const $isOptimizePromptOpen = atom(false);

export function usePromptOptimize() {
  const confirm = useConfirmationModal();
  const isConfirmingOptimization = useStore($isOptimizePromptOpen);

  return [
    isConfirmingOptimization,
    useCallback(
      async (props: Partial<ConfirmationModalData>) => {
        try {
          $isOptimizePromptOpen.set(true);
          const result = await confirm({
            title: 'Optimize image?',
            message: `This image is over ${OPTIMIZATION_THRESHOLD_SIZE_MB}MB. Would you like to optimize it to reduce file size?`,
            confirmLabel: 'Optimize',
            ...props,
          });
          $isOptimizePromptOpen.set(false);
          return result;
        } catch (error) {
          $isOptimizePromptOpen.set(false);
          throw error;
        }
      },
      [confirm],
    ),
  ] as const;
}
